import React from "react";
import { BRAND_NAME, BRAND_ENDORSEMENT, BRAND_LOGO_VARIANT } from "@/config/brand";
import artichautMonogramme from "@/assets/brand/artichaut-monogramme.svg";

// Logo de marque des pages publiques à en-tête propre : monogramme (variante ARTICHAUT),
// nom de marque, mention d'endossement éventuelle. Même composition que le Header.
export default function BrandMark({ className = "" }) {
  return (
    <span className="inline-flex items-center gap-2">
      {BRAND_LOGO_VARIANT === "artichaut" && (
        <img src={artichautMonogramme} alt="" aria-hidden="true" className="w-7 h-7" />
      )}
      <span className="inline-flex items-baseline gap-2">
        <span className={className}>{BRAND_NAME}</span>
        {BRAND_ENDORSEMENT && (
          <span className="text-xs text-gray-400 tracking-wide">{BRAND_ENDORSEMENT}</span>
        )}
      </span>
    </span>
  );
}
